import React from 'react'
import { GoogleAccount, useGoogleAccountStore } from '../../stores/GoogleAccount'
import Swal from 'sweetalert2'
import { signOutGoogle } from '../../api/GoogleCalendar'
import useAccessToken from '../../hooks/AccessToken'
import { useIntl } from 'react-intl'
import { mutate } from 'swr'
import { API_URL } from '../../api/SettingCRUD'
import useUser from '../../hooks/User'
import { useDispatch } from 'react-redux'
import * as auth from '../../app/modules/auth/redux/AuthRedux'

interface BtnSignInAsProp {
  login: () => void
  mutate: () => void
}

const BtnSignInAs = ({ login, mutate }: BtnSignInAsProp) => {
  const user = useUser()
  const token = useAccessToken()
  const intl = useIntl()
  const { googleAccount, isLoadingGoogleAccount, setIsLoadingGoogleAccount, clearGoogleAccount } = useGoogleAccountStore()
  const dispatch = useDispatch()

  const handleSignOut = () => {
    Swal.fire({
      title: intl.formatMessage({ id: "ALERT.TITLE.LOG_OUT" }),
      text: intl.formatMessage({ id: "ALERT.TEXT.LOG_OUT" }),
      icon: "warning",
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.LOG_OUT" }),
      cancelButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.NO" }),
      showLoaderOnConfirm: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-active-light',
      },
      reverseButtons: true,
      heightAuto: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoadingGoogleAccount(true)
          const response = await signOutGoogle(token)
          if (response.success) {
            dispatch(auth.actions.fulfillUser({
              ...user,
              data: {
                ...user.data,
                sync_google_calendar: false
              }
            }))
            clearGoogleAccount()
            mutate()
          }
        } catch (error) {
          console.log(error, 'error')
        } finally {
          setIsLoadingGoogleAccount(false)
        }
      }
    })

  }

  return (
    <button className='btn d-flex align-items-center justify-content-between gap-2 p-2'
      disabled={isLoadingGoogleAccount}
      onClick={login}
      style={{
        border: '0.7px solid #adadad',
        borderRadius: '7px',
        cursor: 'pointer',

      }}>
      <img src={googleAccount?.picture ?? '/media/assets/google.png'} alt='google' style={{
        width: '30px',
        height: '30px',
        borderRadius: '50%',
      }}
        referrerPolicy="no-referrer"
      />
      <div className='d-flex flex-column justify-content-center align-items-start my-auto'>
        <h6 className='text-start my-auto' style={{ fontSize: '12px' }}>{(googleAccount?.name?.length as number) > 20 ? googleAccount?.name.slice(0, 20) + '...' : googleAccount?.name}</h6>
        <p className='text-start my-auto' style={{ fontSize: '10px' }}>{googleAccount?.email}</p>
      </div>
      <button
        disabled={isLoadingGoogleAccount}
        className='btn btn-sm btn-danger justify-content-center align-items-end'
        onClick={(e) => {
          e.stopPropagation();
          handleSignOut();
        }}
      >
        <i className="fas fa-sign-out-alt"></i>
      </button>
    </button>
  )
}

export default BtnSignInAs